<template>
  <hic-dialog v-loading="loading" append-to-body :close-on-click-modal="false" title="导出药品执行单" :visible="visible" width="30rem" top="30vh" @open="open" @close="close()">
    <div>
      病区：
      <hic-dict-selector v-model="condition.wardCode" dict-type="IpWard" placeholder="病区" class="condition-input" size="small" @change="queryPatient"></hic-dict-selector>
    </div>
    <div style="margin-top:20px;margin-bottom:10px">
      患者：
      <el-select v-model="selectPatients" value-key="id" placeholder="请选择患者" multiple clearable size="small" class="right-pad" filterable style="width:240px;margin-left:6px">
        <el-option v-for="item in patients" :key="item.id" :label="`${item.bedNo}：${item.patientName}`" :value="item" style="height: 3rem">
          <el-badge :value="item.news" :hidden="!item.news" style="margin: 0.5rem 0">
            <el-tag size="small" :type="item.news > 0 ? 'danger' : 'info'" class="right-pad">{{ item.bedNo }}</el-tag>
          </el-badge>

          <b>{{ item.patientName }}</b>
          <span>{{ item.patientGender | dictText("Gender") }} {{ item.patientAge }}</span>
        </el-option>
      </el-select>
    </div>

    <div slot="footer">
      <el-button type="primary" size="large" @click="exportExcel">导 出</el-button>
      <el-button type="info" size="large" @click="close()">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import { mapGetters } from "sw-hic";
import api from "./api";
export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      condition: {
        wardCode: null,
        hospitalizationIds: [],
      },
      patients: [],
      selectPatients:[],
    };
  },
  computed: {
    ...mapGetters(["user", "setting"]),
  },
  methods: {
    open() {
      this.queryPatient();
    },
    exportExcel() {
      if (this.selectPatients == null || this.selectPatients.length == 0) {
        this.condition.hospitalizationIds = this.patients.map(p => {
          return p.id;
        });
      } else {
        this.condition.hospitalizationIds = this.selectPatients.map(p => {
          return p.id;
        });
      }

      this.loading = true;
      api.ExportExcel.downloadDrug(this.condition).then((res) => {
        this.$message.success("导出药品执行单成功！");
      }).finally(() => {
        this.loading = false;
      });
    },
    queryPatient() {
      api.Hospitalization.query({
        state: "已入住",
        pageIndexOnView: 1,
        pageSize: 9999,
        deptCode: this.user.deptCode,
        wardCode: this.condition.wardCode,
        sort: "bedNo",
        asc: true,
      }).then((res) => {
        this.patients = res.items;
        if (this.condition.wardCode != null && this.condition.wardCode != '') {
          this.selectPatients = [];
        }
      });
    },
    close() {
      this.$emit('update:visible', false);
    }
  }
}
</script>